import React from "react";
import RadioButtonQuest from '../../../UI/RadioButtonQuest';
import GtmDataLayer from "../../../../Utility/GtmDataLayer";

const WhomResponsible = ({ clsName, onSelectAnswer, backClick, setBckFrmQ108 }) => {

    const optionHandle = async (e) => {
        setBckFrmQ108(e.target.value);
        onSelectAnswer(e);
    }

    return (
        <>
            <div className={`qsSlider slidea1 ${clsName}`}>
                <h2 className="qs-title slide-up-now">
                    Who did you hold responsible for relying on/being stuck in your overdraft?
                </h2>
                <p className="grn-txt"><i>Good to know! Before answering the next questions,
                    reflect on the time when you were primarily overdrawn and reliant on your
                    overdraft. Did you hold anyone responsible for this situation? Did you view it
                    as your own responsibility to manage your finances, or did you believe the
                    lender was at fault for your financial challenges?</i></p>
                <div className="btn-option optinal-items singleqs slide-up-now">
                    <div className=" option_but mb-3">
                        <RadioButtonQuest
                            key="wr1"
                            className="radio"
                            labelName="Blamed Myself – I thought I was solely responsible for my financial issues and
                            did not blame the lender at all this is why I did not complain earlier."
                            onClick={optionHandle}
                            value="381"
                            name="whomresponsible"
                            id="wr1"
                            dataQuestId={124}
                            dataAnsId={381}
                            dataAnsLabel="Blamed Myself"
                        />
                    </div>
                    <div className=" option_but  mb-3">
                        <RadioButtonQuest
                            key="wr2"
                            className="radio"
                            labelName="Blamed Nobody – It did not occur to me to place blame on me or the lender
                            this is why I did not complain earlier."
                            onClick={optionHandle}
                            value="382"
                            name="whomresponsible"
                            id="wr2"
                            dataQuestId={124}
                            dataAnsId={382}
                            dataAnsLabel="Blamed Nobody"
                        />
                    </div>
                    <div className=" option_but  mb-3">
                        <RadioButtonQuest
                            key="wr3"
                            className="radio"
                            labelName="Blamed the Lender"
                            onClick={optionHandle}
                            value="383"
                            name="whomresponsible"
                            id="wr3"
                            dataQuestId={124}
                            dataAnsId={383}
                            dataAnsLabel="Blamed the Lender"
                        />
                    </div>
                </div>
                <div className="mt-2 mb-5 text-center">
                    <div>
                        {" "}
                        <button type="button" className="back-btn mainbckBtn bi bi-chevron-left" id="back02" name="initiallytaken" onClick={backClick}>
                            Back
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WhomResponsible;
